import { ExtractPropTypes } from 'vue'
import type DatePicker from './date-picker.vue'

import { buildProps } from '@ll-plus/utils'

export const datePickerProps = buildProps({
  isGray: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type DatePickerProps = ExtractPropTypes<typeof datePickerProps>

// instance
export type DatePickerInstance = InstanceType<typeof DatePicker>
